(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-cart-root]');
    if (!root) return;

    // --- Qty stepper ---
    root.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        const line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        const delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
        const row = qtyBtn.closest('[data-line-key]');
        const current = parseInt(row.querySelector('.main-cart__qty-value').textContent, 10);
        const next = Math.max(0, current + delta);
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: next }),
          });
          window.location.reload();
        } catch (err) {
          console.error('Cart change failed', err);
        }
        return;
      }
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const line = parseInt(removeBtn.getAttribute('data-line'), 10);
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 0 }),
          });
          window.location.reload();
        } catch (err) {
          console.error('Cart remove failed', err);
        }
      }
    });

    // --- Note auto-save on blur ---
    const noteEl = root.querySelector('[data-cart-note]');
    const noteFeedback = root.querySelector('[data-cart-note-feedback]');
    if (noteEl) {
      let lastSaved = noteEl.value;
      noteEl.addEventListener('blur', async () => {
        if (noteEl.value === lastSaved) return;
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: noteEl.value }),
          });
          lastSaved = noteEl.value;
          if (noteFeedback) {
            noteFeedback.textContent = noteFeedback.getAttribute('data-saved-label') || 'Note saved.';
            noteFeedback.setAttribute('data-visible', 'true');
            setTimeout(() => noteFeedback.setAttribute('data-visible', 'false'), 2000);
          }
        } catch (err) {
          console.error('Note save failed', err);
        }
      });
    }

    // --- Discount apply ---
    // Uses Shopify's /discount/<code>?redirect=/cart URL pattern: applies the
    // code and lands the user back on the cart page with the discount active.
    const discountForm = root.querySelector('[data-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const input = discountForm.querySelector('input[name="discount"]');
        if (!input) return;
        const code = input.value.trim();
        if (!code) return;
        window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/cart');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cham-review-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var INTERVAL_MS = 4000;

    function initSlider(root) {
      var viewport = root.querySelector('.celebrity-slider__viewport');
      var track = root.querySelector('.celebrity-slider__track');
      var cards = root.querySelectorAll('.celebrity-slider__card:not(.celebrity-slider__card--clone)');
      var prevButton = root.querySelector('.celebrity-slider__nav-button--prev');
      var nextButton = root.querySelector('.celebrity-slider__nav-button--next');

      if (!viewport || !track || cards.length < 2) return;

      // Re-init (theme editor section reload) must not stack a second timer.
      if (root.dataset.celebritySliderTimer) {
        clearInterval(Number(root.dataset.celebritySliderTimer));
      }

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var hovered = false;
      var focused = false;
      var timer = null;

      function step() {
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
        return cards[0].offsetWidth + gap;
      }

      function apply(animate) {
        if (!animate) track.style.transition = 'none';
        track.style.transform = 'translateX(-' + index * step() + 'px)';
        if (!animate) {
          void track.offsetHeight;
          track.style.transition = '';
        }
      }

      // Runs fn once the slide settles. Under reduced motion the track has no
      // transition, so transitionend never fires — call it straight away.
      function afterSlide(fn) {
        if (reduced) {
          fn();
          return;
        }
        var done = function (event) {
          if (event.target !== track || event.propertyName !== 'transform') return;
          track.removeEventListener('transitionend', done);
          fn();
        };
        track.addEventListener('transitionend', done);
      }

      function goNext() {
        index += 1;
        apply(true);
        // Past the last real card we are showing the clone set; once the slide
        // settles, jump silently back to the identical real position.
        if (index >= cards.length) {
          afterSlide(function () {
            index -= cards.length;
            apply(false);
          });
        }
      }

      function goPrev() {
        // Nothing sits to the left of the first card, so hop to the clone set
        // first — position N renders the same cards as position 0 — and slide
        // backwards out of that.
        if (index === 0) {
          index = cards.length;
          apply(false);
        }
        index -= 1;
        apply(true);
      }

      function startTimer() {
        if (reduced) return;
        clearInterval(timer);
        timer = setInterval(function () {
          if (!hovered && !focused) goNext();
        }, INTERVAL_MS);
        root.dataset.celebritySliderTimer = String(timer);
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goPrev();
          startTimer();
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goNext();
          startTimer();
        });
      }

      // Touch swipe. Bound to touch and pen only — leaving mouse pointers alone
      // keeps the quotes selectable on desktop, where the nav buttons already do
      // this job.
      var dragPointer = null;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragDelta = 0;
      var dragAxis = '';

      function endDrag() {
        dragPointer = null;
        dragAxis = '';
        track.style.transition = '';
      }

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' || dragPointer !== null) return;
        dragPointer = event.pointerId;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        dragDelta = 0;
        dragAxis = '';
      });

      viewport.addEventListener('pointermove', function (event) {
        if (event.pointerId !== dragPointer) return;

        var dx = event.clientX - dragStartX;
        var dy = event.clientY - dragStartY;

        // Wait for enough travel to tell a swipe from a tap, then commit to one
        // axis for the rest of the gesture so a drifting finger can't flip it.
        if (!dragAxis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) >= Math.abs(dx)) {
            endDrag();
            return;
          }
          dragAxis = 'x';
          // Nothing sits to the left of the first card, so a rightward drag opens
          // by hopping to the clone set — the same sleight of hand as goPrev().
          if (dx > 0 && index === 0) index = cards.length;
          track.style.transition = 'none';
          viewport.setPointerCapture(event.pointerId);
        }

        dragDelta = dx;
        track.style.transform = 'translateX(' + (dragDelta - index * step()) + 'px)';
      });

      function releaseDrag(event) {
        if (event.pointerId !== dragPointer) return;

        var moved = dragAxis === 'x' ? dragDelta : 0;
        endDrag();
        if (moved === 0) return;

        // A fifth of a card reads as intent without demanding a full-width fling.
        var threshold = Math.min(step() * 0.2, 90);

        if (moved <= -threshold) {
          goNext();
        } else if (moved >= threshold) {
          goPrev();
        } else {
          apply(true);
          // An abandoned rightward drag can leave us parked on the clone set.
          afterSlide(function () {
            if (index >= cards.length) {
              index -= cards.length;
              apply(false);
            }
          });
        }

        startTimer();
      }

      viewport.addEventListener('pointerup', releaseDrag);
      viewport.addEventListener('pointercancel', releaseDrag);

      // A swipe that happens to end on the Instagram chip must not open the link.
      viewport.addEventListener(
        'click',
        function (event) {
          if (Math.abs(dragDelta) <= 8) return;
          dragDelta = 0;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      startTimer();

      // Reading a quote should not have it slide away mid-sentence. Hover and focus
      // are tracked separately — one flag would let a pointer leaving the section
      // resume playback while a nav button still held keyboard focus, and the
      // reverse.
      root.addEventListener('mouseenter', function () {
        hovered = true;
      });
      root.addEventListener('mouseleave', function () {
        hovered = false;
      });
      root.addEventListener('focusin', function () {
        focused = true;
      });
      root.addEventListener('focusout', function () {
        focused = false;
      });

      window.addEventListener('resize', function () {
        apply(false);
      });
    }

    /*
     * Cards that carry a reel autoplay it muted while they are on screen and
     * stop once they leave, so the carousel costs two streams rather than
     * fourteen. Sound lives in the fullscreen viewer, which a click opens on the
     * card that was clicked.
     *
     * The clone pass is deliberately included: the track scrolls through the
     * clones before it snaps back, so a still frame there would read as the
     * videos stopping halfway round.
     */
    function initVideos(root) {
      // init() runs again on shopify:section:load; a second observer and click
      // handler on the same cards would double every play call.
      if (root.dataset.celebrityVideosReady === 'true') return;

      var media = Array.prototype.slice.call(root.querySelectorAll('.celebrity-slider__media--video'));
      if (!media.length) return;
      root.dataset.celebrityVideosReady = 'true';

      // Every card's reel, deduplicated across the clone pass, in carousel order.
      var reels = [];
      var seen = {};
      media.forEach(function (item) {
        var video = item.querySelector('video');
        var name = video && video.getAttribute('data-celebrity-name');
        if (!video || seen[name]) return;
        seen[name] = true;
        var source = video.querySelector('source');
        reels.push({
          name: name,
          src: source ? source.src : '',
          poster: video.getAttribute('poster') || '',
          label: name,
        });
      });

      root.addEventListener('click', function (event) {
        var item = event.target.closest('.celebrity-slider__media--video');
        if (!item || !window.ChamReels) return;
        var video = item.querySelector('video');
        var name = video && video.getAttribute('data-celebrity-name');
        var index = reels.findIndex(function (reel) {
          return reel.name === name;
        });
        window.ChamReels.open(reels, index < 0 ? 0 : index);
      });

      if (!('IntersectionObserver' in window)) return;

      // The card tracks the element's own play/pause events rather than what
      // play() resolves to. The carousel keeps sliding while a reel is still
      // loading, so those promises interleave with the pause that follows and
      // settle in an order that does not describe what is on screen.
      media.forEach(function (item) {
        var video = item.querySelector('video');
        if (!video) return;
        video.addEventListener('play', function () {
          item.setAttribute('data-playing', 'true');
        });
        video.addEventListener('pause', function () {
          item.setAttribute('data-playing', 'false');
        });
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.intersectionRatio >= 0.6) video.play().catch(function () {});
            else video.pause();
          });
        },
        { threshold: [0, 0.6, 1] }
      );
      media.forEach(function (item) {
        observer.observe(item);
      });
    }

    function init() {
      document.querySelectorAll('.celebrity-slider').forEach(function (root) {
        initSlider(root);
        initVideos(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    if (header) {
      const update = () => {
        const scrolled = window.scrollY > 24;
        header.setAttribute('data-scrolled', scrolled ? 'true' : 'false');
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    }

    const openBtn = document.querySelector('[data-mobile-menu-open]');
    const closeBtn = document.querySelector('[data-mobile-menu-close]');
    const menu = document.querySelector('[data-mobile-menu]');

    if (openBtn && menu) {
      openBtn.addEventListener('click', () => {
        menu.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
    }
    if (closeBtn && menu) {
      closeBtn.addEventListener('click', () => {
        menu.hidden = true;
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }

    // Close mobile menu when a link is clicked. `:not([data-mobile-nav-toggle])`
    // matters: a dropdown parent shares the .mobile-menu__link class, and without
    // the exclusion tapping it to reveal its children would close the whole menu.
    const closers = '.mobile-menu__link:not([data-mobile-nav-toggle]), .mobile-menu__sublink';
    document.querySelectorAll(closers).forEach((link) => {
      link.addEventListener('click', () => {
        if (menu) menu.hidden = true;
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });

    // Mobile dropdown disclosure.
    document.querySelectorAll('[data-mobile-nav-toggle]').forEach((toggle) => {
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });

    // Desktop dropdown. Hover and keyboard focus are handled in CSS; this adds
    // click (the only way in on a touch device, where :hover never resolves),
    // Escape, and click-outside.
    const dropdowns = document.querySelectorAll('[data-nav-dropdown]');

    function closeDropdowns(except) {
      dropdowns.forEach((dropdown) => {
        if (dropdown === except) return;
        const toggle = dropdown.querySelector('[data-nav-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector('[data-nav-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const open = toggle.getAttribute('aria-expanded') === 'true';
        closeDropdowns(dropdown);
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });

      // Escape closes but keeps focus on the toggle, so a keyboard user is not
      // dumped back to the top of the document.
      dropdown.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      });
    });

    if (dropdowns.length > 0) {
      document.addEventListener('click', (event) => {
        let node = event.target;
        while (node) {
          if (node.hasAttribute && node.hasAttribute('data-nav-dropdown')) return;
          node = node.parentElement;
        }
        closeDropdowns(null);
      });
    }

    // Theme toggle.
    document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const current = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
        const next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        try {
          localStorage.setItem('cham-theme', next);
        } catch (e) {}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fireNewsletterConfetti() {
      var target = document.querySelector('[data-newsletter-success]');
      if (!target || target.dataset.confettiFired === '1') return;
      target.dataset.confettiFired = '1';

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;

      var canvas = document.createElement('canvas');
      canvas.className = 'home-newsletter__confetti-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;

      function size() {
        canvas.width = window.innerWidth * dpr;
        canvas.height = window.innerHeight * dpr;
        canvas.style.width = window.innerWidth + 'px';
        canvas.style.height = window.innerHeight + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      size();
      window.addEventListener('resize', size);

      var root = getComputedStyle(document.documentElement);
      function token(name, fallback) {
        var v = root.getPropertyValue(name).trim();
        return v || fallback;
      }
      var colors = [
        token('--primary', '#c89a4a'),
        token('--primary-glow', '#e4b770'),
        token('--foreground', '#2f261b'),
        '#f5e8d3',
        '#e8c79a'
      ];

      var rect = target.getBoundingClientRect();
      var originX = rect.left + rect.width / 2;
      var originY = rect.top + rect.height / 3;

      var particles = [];
      var count = 160;
      for (var i = 0; i < count; i++) {
        var angle = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.1;
        var speed = 6 + Math.random() * 11;
        particles.push({
          x: originX,
          y: originY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          size: 4 + Math.random() * 7,
          color: colors[(Math.random() * colors.length) | 0],
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.35,
          life: 1,
          decay: 0.006 + Math.random() * 0.006
        });
      }

      function tick() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var alive = false;
        for (var j = 0; j < particles.length; j++) {
          var p = particles[j];
          if (p.life <= 0) continue;
          alive = true;
          p.vy += 0.22;
          p.vx *= 0.992;
          p.x += p.vx;
          p.y += p.vy;
          p.rot += p.vr;
          p.life -= p.decay;
          ctx.save();
          ctx.globalAlpha = Math.max(p.life, 0);
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.45);
          ctx.restore();
        }
        if (alive) {
          requestAnimationFrame(tick);
        } else {
          window.removeEventListener('resize', size);
          canvas.remove();
        }
      }
      requestAnimationFrame(tick);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fireNewsletterConfetti);
    } else {
      fireNewsletterConfetti();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-collection-root]').forEach((root) => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      const filters = root.querySelectorAll('[data-filter]');
      const items = root.querySelectorAll('[data-collection-item]');
      const counter = root.querySelector('[data-collection-count]');
      if (!filters.length || !items.length) return;

      const singular = counter ? counter.getAttribute('data-singular') || 'item' : 'item';
      const plural = counter ? counter.getAttribute('data-plural') || 'items' : 'items';

      function applyFilter(value) {
        let visible = 0;
        items.forEach((item) => {
          const cat = item.getAttribute('data-category') || '';
          const match = value === 'all' || cat === value;
          if (match) {
            item.removeAttribute('data-hidden');
            visible += 1;
          } else {
            item.setAttribute('data-hidden', 'true');
          }
        });
        if (counter) {
          counter.textContent = visible + ' ' + (visible === 1 ? singular : plural);
        }
      }

      filters.forEach((btn) => {
        btn.addEventListener('click', () => {
          const value = btn.getAttribute('data-filter-value');
          filters.forEach((b) => {
            const isActive = b === btn;
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          applyFilter(value);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-body-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-body-map]');
    if (!root) return;

    var navItems = Array.prototype.slice.call(root.querySelectorAll('[data-body-map-nav]'));
    var zones = Array.prototype.slice.call(root.querySelectorAll('[data-body-map-zone]'));
    var allBtn = root.querySelector('[data-body-map-all]');
    if (!navItems.length || !zones.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function track(zone) {
      if (!window.dataLayer) return;
      window.dataLayer.push({ event: 'body_map_zone', body_zone: zone });
    }

    function showOnly(id) {
      zones.forEach(function (z) {
        z.hidden = z.getAttribute('data-body-map-zone') !== id;
      });
      navItems.forEach(function (n) {
        n.setAttribute('aria-current', n.getAttribute('data-body-map-nav') === id ? 'true' : 'false');
      });
      if (allBtn) allBtn.hidden = false;
      var active = root.querySelector('[data-body-map-zone="' + id + '"]');
      if (active) {
        active.setAttribute('tabindex', '-1');
        active.focus({ preventScroll: true });
        active.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      }
    }

    function showAll() {
      zones.forEach(function (z) {
        z.hidden = false;
      });
      navItems.forEach(function (n) {
        n.setAttribute('aria-current', 'false');
      });
      if (allBtn) allBtn.hidden = true;
    }

    navItems.forEach(function (item) {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        var id = item.getAttribute('data-body-map-nav');
        showOnly(id);
        track(id);
      });
    });

    if (allBtn) allBtn.addEventListener('click', showAll);

    // Deep links from the figure panel (and from anywhere else) filter the
    // detailed list to the requested zone.
    function applyHash() {
      var id = window.location.hash.replace('#', '');
      if (!id) return;
      var match = zones.some(function (z) {
        return z.getAttribute('data-body-map-zone') === id;
      });
      if (match) showOnly(id);
    }

    window.addEventListener('hashchange', applyHash);
    if (window.location.hash) applyHash();
  })();

  (function () {
    var root = document.querySelector('[data-body-figure]');
    if (!root) return;

    var stage = root.querySelector('[data-figure-stage]');
    var spotGroups = Array.prototype.slice.call(root.querySelectorAll('[data-spots]'));
    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-figure-spot]'));
    var regions = Array.prototype.slice.call(root.querySelectorAll('.body-figure__region'));
    var panel = root.querySelector('[data-figure-panel]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-zone-panel]'));
    var viewButtons = Array.prototype.slice.call(root.querySelectorAll('[data-figure-view]'));
    if (!spots.length || !panel) return;

    var desktop = window.matchMedia('(min-width: 1024px)');
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var selected = null;

    function track(zone) {
      if (!window.dataLayer) return;
      window.dataLayer.push({ event: 'body_map_zone', body_zone: zone, body_map_source: 'figure' });
    }

    function showCard(zone) {
      var found = false;
      cards.forEach(function (card) {
        var match = zone && card.getAttribute('data-zone-panel') === zone;
        if (match) found = true;
        card.hidden = !match;
      });
      if (!found) {
        cards.forEach(function (card) {
          if (card.getAttribute('data-zone-panel') === '') card.hidden = false;
        });
      }
    }

    function setRegions(zone, cls, on) {
      regions.forEach(function (region) {
        if (region.getAttribute('data-region') === zone) region.classList.toggle(cls, on);
      });
    }

    function select(zone, opts) {
      opts = opts || {};
      selected = zone;
      showCard(zone);
      spots.forEach(function (spot) {
        spot.setAttribute('aria-pressed', spot.getAttribute('data-figure-spot') === zone ? 'true' : 'false');
      });
      regions.forEach(function (region) {
        region.classList.toggle('is-on', region.getAttribute('data-region') === zone);
      });
      panel.classList.add('is-open');
      if (!opts.silent) {
        if (!desktop.matches) {
          panel.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'nearest' });
        }
        track(zone);
      }
    }

    spots.forEach(function (spot) {
      var zone = spot.getAttribute('data-figure-spot');

      spot.addEventListener('click', function () {
        select(zone);
      });

      spot.addEventListener('mouseenter', function () {
        if (!hoverable.matches) return;
        setRegions(zone, 'is-hot', true);
        if (desktop.matches) showCard(zone);
      });

      spot.addEventListener('mouseleave', function () {
        setRegions(zone, 'is-hot', false);
        if (desktop.matches) showCard(selected);
      });

      spot.addEventListener('focus', function () {
        if (desktop.matches) showCard(zone);
      });

      spot.addEventListener('blur', function () {
        if (desktop.matches) showCard(selected);
      });
    });

    viewButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var view = button.getAttribute('data-figure-view');
        stage.setAttribute('data-view', view);
        spotGroups.forEach(function (group) {
          group.hidden = group.getAttribute('data-spots') !== view;
        });
        viewButtons.forEach(function (b) {
          b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
        });
      });
    });

    panel.addEventListener('click', function (event) {
      var target = event.target;
      var link = target.closest ? target.closest('[data-figure-cta]') : null;
      if (!link || !window.dataLayer) return;
      window.dataLayer.push({ event: 'body_map_zone_cta', body_zone: link.getAttribute('data-figure-cta') });
    });

    // Desktop opens on a zone so the panel is never an empty box; on mobile
    // the panel stays tucked away until a zone is tapped.
    if (desktop.matches) {
      select(root.getAttribute('data-default-zone'), { silent: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-melasma-planner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-melasma-planner]');
    if (!root) return;

    var buttons = root.querySelectorAll('[data-melasma-branch]');
    var panels = root.querySelectorAll('[data-melasma-panel]');
    var gate = root.querySelector('[data-melasma-gate]');
    var tags = root.querySelector('[data-melasma-tags]');

    function track(event, branch) {
      if (!window.dataLayer) return;
      window.dataLayer.push({ event: event, melasma_branch: branch });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var branch = btn.getAttribute('data-melasma-branch');
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-melasma-panel') !== branch;
        });
        var gated = branch !== 'confirm';
        if (gate) gate.hidden = !gated;
        if (gated && tags) tags.value = 'melasma-plan,melasma-plan-' + branch;
        var active = root.querySelector('[data-melasma-panel="' + branch + '"]');
        if (active) {
          active.setAttribute('tabindex', '-1');
          active.focus();
        }
        track('melasma_planner_branch', branch);
      });
    });

    var form = gate ? gate.querySelector('form') : null;
    if (form) {
      form.addEventListener('submit', function () {
        var pressed = root.querySelector('[data-melasma-branch][aria-pressed="true"]');
        track('melasma_planner_capture', pressed ? pressed.getAttribute('data-melasma-branch') : '');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-video-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-video-player]').forEach((player) => {
      const video = player.querySelector('[data-video]');
      if (!video) return;
      const toggles = player.querySelectorAll('[data-video-toggle]');
      const muteBtn = player.querySelector('[data-video-mute]');

      function setPlaying() {
        player.setAttribute('data-playing', video.paused ? 'false' : 'true');
      }
      function setMuted() {
        player.setAttribute('data-muted', video.muted ? 'true' : 'false');
      }

      toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });

      video.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      if (muteBtn) {
        muteBtn.addEventListener('click', (e) => {
          e.preventDefault();
          video.muted = !video.muted;
          setMuted();
        });
      }

      video.addEventListener('play', setPlaying);
      video.addEventListener('pause', setPlaying);

      setPlaying();
      setMuted();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-video-player]').forEach((player) => {
      if (player.dataset.bound === 'true') return;
      player.dataset.bound = 'true';
      const video = player.querySelector('[data-video]');
      if (!video) return;
      const toggles = player.querySelectorAll('[data-video-toggle]');
      const muteBtn = player.querySelector('[data-video-mute]');

      function setPlaying() {
        player.setAttribute('data-playing', video.paused ? 'false' : 'true');
      }
      function setMuted() {
        player.setAttribute('data-muted', video.muted ? 'true' : 'false');
      }

      toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });

      video.addEventListener('click', () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });

      if (muteBtn) {
        muteBtn.addEventListener('click', (e) => {
          e.preventDefault();
          video.muted = !video.muted;
          setMuted();
        });
      }

      video.addEventListener('play', setPlaying);
      video.addEventListener('pause', setPlaying);

      setPlaying();
      setMuted();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var videos = document.querySelectorAll('[data-reviews-video]');
    videos.forEach(function (video) {
      video.addEventListener('play', function () {
        videos.forEach(function (other) {
          if (other !== video && !other.paused) other.pause();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
